module.exports = __webpack_public_path__ + "img/button_delete_close_x.46c68c85.svg";